// extracted by mini-css-extract-plugin
module.exports = {"life":"ClubLife_life__1AOnJ","spin":"ClubLife_spin__2OBDE"};